'use client';

import clsx from 'clsx';
import styles from './button.module.css';
import { useEffect, useState } from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    text: string;
    icon?: React.ReactNode;
    className?: string;
    buttonRef?: React.Ref<HTMLButtonElement>;
}

export function Button({
    text,
    icon,
    buttonRef,
    className,
    ...rest
}: Readonly<ButtonProps>) {
    const [textChars, setTextChars] = useState<string[]>([]);

    useEffect(() => {
        if (text === undefined) {
            return;
        }
        setTextChars(text.split(''));
    }, [text]);

    return (
        <button
            ref={buttonRef}
            {...rest}
            style={{}}
            className={clsx(
                'flex h-10 items-center rounded-[72px] px-[18px] text-white',
                className,
                styles.button,
            )}
        >
            <div
                className={clsx(
                    'flex flex-row items-center gap-[4px]',
                    styles.div,
                    {
                        'justify-center': !icon,
                        'justify-between': icon,
                    },
                )}
            >
                <div className="flex flex-row">
                    {textChars.map((char, index) => (
                        <span
                            key={index + char}
                            className={styles.span}
                            style={{ whiteSpace: 'pre-wrap' }}
                        >
                            {char}
                        </span>
                    ))}
                </div>
                {icon}
            </div>
        </button>
    );
}
